import React from "react";
import CustomButtonLink from "../../../../components/buttons/CustomButtonLink";
import {VIEW_TYPE} from "../../../../enums/ViewType";
import GuardRosterApp from "../Functionality/GuardRosterApp";
import GuardRosterTable from "./GuardRosterTable";
import GuardRosterCards from "./GuardRosterCards";

/**
 * Roster tab of the guards module, as a table or as cards.
 */
const GuardRoster = ({
    selectedList, setSelectedList, modified, setModified, setDeleteModal, goCreate,
    searchElement, setSearchElement, setSearch, setBodyForExport, setCriteria, finalArray, resetSearch,
}) => {
    const {
        t,
        setSimpleSearch,
        option,
        view,
        handleView,
        isAllChecked,
        setIsAllChecked,
        goUpdate,
        canUpdate,
        canDelete,
        canCreate,
    } = GuardRosterApp({
        setSelectedList,
        resetSearch,
    });

    const emptyRoster = (
        <>
            <div className={"warning-text"}>
                <p>{t("you_have_not_created_any_guards_yet")}</p>
            </div>
            {canCreate &&
                <CustomButtonLink
                    splitName={false}
                    id={'btn_gr_create'}
                    card={true}
                    onClick={goCreate}
                    name={'create_new_guard'}
                />
            }
        </>
    );

    return view === VIEW_TYPE.GRID.name
        ? <GuardRosterCards
            selectedList={selectedList}
            setSelectedList={setSelectedList}
            modified={modified}
            setModified={setModified}
            isAllChecked={isAllChecked}
            setIsAllChecked={setIsAllChecked}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            setSearch={setSearch}
            setSimpleSearch={setSimpleSearch}
            setBodyForExport={setBodyForExport}
            setCriteria={setCriteria}
            finalArray={finalArray}
            option={option}
            view={view}
            handleView={handleView}
            goUpdate={goUpdate}
            canUpdate={canUpdate}
            canDelete={canDelete}
            emptyRoster={emptyRoster}
        />
        : <GuardRosterTable
            selectedList={selectedList}
            setSelectedList={setSelectedList}
            modified={modified}
            setModified={setModified}
            setDeleteModal={setDeleteModal}
            isAllChecked={isAllChecked}
            setIsAllChecked={setIsAllChecked}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            setSearch={setSearch}
            setSimpleSearch={setSimpleSearch}
            setBodyForExport={setBodyForExport}
            setCriteria={setCriteria}
            finalArray={finalArray}
            option={option}
            view={view}
            handleView={handleView}
            goUpdate={goUpdate}
            canUpdate={canUpdate}
            canDelete={canDelete}
            emptyRoster={emptyRoster}
        />;
};

export default GuardRoster;
